export function createTemplate(id, html){
    const template = document.createElement("template") ;
    template.id = id ;
    document.body.appendChild(template) ;
    template.innerHTML = html ;
    return template ;
}

export function fetchAndCreateTemplate(id, url){
    return fetch(url)
    .then((response) => {
        return response.text()
    }).then((html)=>{
        return Promise.resolve(createTemplate(id, html)) ;
    });
}

export function getTemplate(id, url){
    let template = document.getElementById(id);
    if(template){
        return Promise.resolve(template) ;
    }
    return fetchAndCreateTemplate(id, url) ;
}